'use client';
import { useTypedTranslation } from '@/hooks/useTypedTranslation';
import styles from './MerchantsBenefits.module.css';
import Image from 'next/image';

export default function MerchantsBenefits({ selectedMarket }: { selectedMarket: 'es' | 'it' }) {
  const { t } = useTypedTranslation();

  const benefits = [
    {
      icon: '/images/icons/legal-document.svg',
      title: t('merchants.benefits.legalAccuracy.title'),
      description: t('merchants.benefits.legalAccuracy.description'),
    },
    {
      icon: '/images/icons/shield.svg',
      title: t('merchants.benefits.noRisk.title'),
      description: t('merchants.benefits.noRisk.description'),
    },
    {
      icon: '/images/icons/customer-impact.svg',
      title: t('merchants.benefits.customerImpact.title'),
      description: t('merchants.benefits.customerImpact.description'),
    },
    {
      icon: '/images/icons/workflow.svg',
      title: t('merchants.benefits.simpleWorkflow.title'),
      description: t('merchants.benefits.simpleWorkflow.description'),
    },
    {
      icon: '/images/icons/free.svg',
      title: t('merchants.benefits.alwaysFree.title'),
      description: t('merchants.benefits.alwaysFree.description'),
    },
  ];

  return (
    <section className={styles.benefitsSection}>
      <div className={styles.container}>
        <div className={styles.contentContainer}>
          <div className={styles.content}>
            <h2 className={styles.heading}>{t('merchants.benefits.heading')}</h2>
            <p className={styles.subheading}>{t('merchants.benefits.subheading')}</p>
          </div>
          <div className={styles.benefitsList}>
            {benefits.map((benefit, index) => (
              <div key={index} className={styles.benefitItem}>
                <div className={styles.iconContainer}>
                  <Image
                    src={benefit.icon}
                    alt=""
                    width={32}
                    height={32}
                    className={styles.benefitIcon}
                  />
                </div>
                <div className={styles.benefitTextContainer}>
                  <h3 className={styles.benefitTitle}>{benefit.title}</h3>
                  <p className={styles.benefitDescription}>{benefit.description}</p>
                </div>
              </div>
            ))}
          </div>
        </div>

        <div className={styles.ctaContainer}>
          <a
            href={selectedMarket == "it" ? "https://sales.askforstamp.com/it/contact" : "https://sales.askforstamp.com/contact"}
            target="_blank"
            className={styles.ctaButton}
          >
            {t('merchants.benefits.ctaText')}
          </a>
        </div>
      </div>
    </section>
  );
}
